export default "data:image/svg+xml,%3csvg%20height='8'%20width='8'%20xmlns='http://www.w3.org/2000/svg'/%3e"